/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Item } from 'libs/sysque/toolbelt/data-access/src/lib/domain/item';

export class PastedItemsInfo {
  srcSystemName: string;
  destSystemName: string;
  category: string;
  copiedItem: Item;
  isDuplicate: boolean;
  isReplace: boolean;
  isReplaceAll: boolean;
  isCancel: boolean;
  destCategory : string;
  isDestCustomContent: string;
}
